import { FC } from 'react';
import { TbChevronRight } from 'react-icons/tb';

import { Box, Group, Loader, Stack, Text, UnstyledButton } from '@mantine/core';

import { useInvitableCompanies } from '@diagram/hooks/use-invitable-companies';

import { CompanyProfile } from 'models';

import { Logo } from 'components/company-profile-teaser/components/Logo';

import cx from './InvitableCompanyList.module.scss';

const InvitableCompanyList: FC<{
    onSelect: (company: CompanyProfile) => void;
    excludeIds?: CompanyProfile['id'][];
}> = ({ onSelect, excludeIds = [] }) => {
    const { companies, isLoading } = useInvitableCompanies();

    if (isLoading) {
        return (
            <Group justify="center" p="md">
                <Loader size="sm" />
            </Group>
        );
    }

    return (
        <Stack gap={4}>
            {companies
                .filter((company) => !excludeIds.includes(company.id))
                .map((company) => (
                    <UnstyledButton key={company.id} onClick={() => onSelect(company)} p="xs" className={cx.row}>
                        <Group justify="space-between" wrap="nowrap" gap="xs">
                            <Group gap="sm" wrap="nowrap" miw={0}>
                                <Logo company={company} size={36} withBorder />
                                <Box miw={0}>
                                    <Text size="sm" fw={500}>
                                        {company.name}
                                    </Text>
                                    {company.editorSupport?.description && (
                                        <Text size="xs" c="dimmed">
                                            {company.editorSupport.description}
                                        </Text>
                                    )}
                                </Box>
                            </Group>
                            <TbChevronRight />
                        </Group>
                    </UnstyledButton>
                ))}
        </Stack>
    );
};

export { InvitableCompanyList };
